import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    if (this.inputTarget.value) this._aplicarMascara()
  }

  bloquearLetras(event) {
    const permitidas = [
      "Backspace", "Delete", "Tab", "Escape", "Enter",
      "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
      "Home", "End"
    ]
    if (event.ctrlKey || event.metaKey) return
    if (permitidas.includes(event.key)) return
    if (/^\d$/.test(event.key)) return
    event.preventDefault()
  }

  colarSoDigitos(event) {
    event.preventDefault()
    const texto = (event.clipboardData || window.clipboardData).getData("text")
    const digitos = this._soDigitos(texto).slice(0, 9)
    this.inputTarget.value = this._mascarar(digitos)
  }

  mascara() {
    const digitos = this._soDigitos(this.inputTarget.value).slice(0, 9)
    this.inputTarget.value = this._mascarar(digitos)
  }

  _aplicarMascara() {
    const digitos = this._soDigitos(this.inputTarget.value).slice(0, 9)
    this.inputTarget.value = this._mascarar(digitos)
  }

  _mascarar(v) {
    if (v.length > 8) return v.replace(/^(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4")
    if (v.length > 5) return v.replace(/^(\d{2})(\d{3})(\d{1,3})$/, "$1.$2.$3")
    if (v.length > 2) return v.replace(/^(\d{2})(\d{1,3})$/, "$1.$2")
    return v
  }

  _soDigitos(valor) {
    return (valor || "").replace(/\D/g, "")
  }
}